import * as React from 'react';
import Div from '../components/Div.styled';
import {Feature} from '../types/resultMap';
import Info from '../assets/svgs/Info';
import useMediaQuery from '../hooks/useMediaQuery';
import BodyText from '../components/BodyText';
import {TextAlignment} from '@volkswagen-onehub/components-core';

export interface IFeatureCardProps {
  cardItem: Feature | undefined;
  onClickInfoCard: () => void;
}

export const FeatureCard = ({cardItem, onClickInfoCard}: IFeatureCardProps) => {
  const {isDesktop} = useMediaQuery();
  if (!cardItem) {
    return null;
  }

  return (
    <Div
      key={cardItem?.title_line_1}
      customStyles={{
        overflow: 'auto',
        position: 'relative',
        border: '1px solid #96A3A8',
        borderRadius: 8,
        flex: '1',
        minWidth: '267px',
        transform: !isDesktop ? 'translateX(32px)' : '',
        padding: cardItem?.disclaimer
          ? '16px 16px 0px 16px'
          : '16px 16px 32px 16px',
      }}
      width="267px"
    >
      <Div
        customStyles={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Div
          customStyles={{
            textAlign: 'left',
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
          }}
        >
          <BodyText
            align={TextAlignment.left}
            color="black"
            weight="400"
            size="16px"
          >
            {cardItem.title_line_1}
          </BodyText>
          <BodyText
            size={isDesktop ? '24px' : '20px'}
            color="black"
            weight={'700'}
          >
            {cardItem.title_line_2}
          </BodyText>
          {cardItem.disclaimer && (
            <BodyText size="12px" color="black" weight={'400'}>
              {cardItem.disclaimer}
            </BodyText>
          )}
        </Div>
        {cardItem.info && (
          <button
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              padding: '0',
            }}
            className="button-icon"
            onClick={onClickInfoCard}
          >
            <Info />
          </button>
        )}
      </Div>
    </Div>
  );
};
